export default __webpack_public_path__ + "static/media/cheese-pasta.00dea41d.jpg";